import React from "react";
// import { withStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import { Il8nContext } from '../../Helper/i18n'
import {useContext} from 'react';
import { Dialog, DialogTitle, DialogContent, Tooltip, IconButton, Grid, Typography, Button, CircularProgress, useTheme } from "@mui/material";

function NomineeEsignDialog(props) {
  const theme = useTheme()
  const localeText = useContext(Il8nContext)


    
  const { data, handleClose, loading, onEsignClick, clientLoading, clientName } = props;
  const classes = {
    root: {
      padding: theme.spacing(4),
      boxShadow: "0px 0px 6px 1px #f999996b",
    },
    title: {
      color: "#2A2A2A",
      fontWeight: 600,
      marginBottom: theme.spacing(5),
    },
    underline: {
      borderBottom: "2px solid #F54040",
      padding: "0px 16px 8px 0px",
    },
    titleMargin: {
      marginTop: theme.spacing(2),
    },
    button: {
      // width: theme.spacing(19),
      height: theme.spacing(7),
      marginTop: theme.spacing(4),
      textTransform: "none",
    },
    textMargin1: {
      marginBottom: theme.spacing(2.5),
    },
    textMargin2: {
      marginBottom: theme.spacing(2),
    },
    headingMargin: {
      marginBottom: theme.spacing(2.5),
      fontWeight: "800",
    },
    lastTextMargin: {
      marginBottom: theme.spacing(4),
    },
    flex: {
      display: "flex",
      flexDirection: "row",
      marginBottom: theme.spacing(2),
    },
    image: {
      width: theme.spacing(3),
      marginRight: theme.spacing(1),
    },
    font: {
      fontSize: "14px",
    },
    downloadButton: {
      textTransform: "none",
      fontWeight: 600,
      boxShadow: "0px 0px 4px 4px rgb(244, 244, 245)",
      padding: "5px 25px",
    },
    listBullet: {
      listStyle: "none",
      paddingInlineStart: "25px",
      marginLeft: "3px",
      "&>li": {
        display: "flex",
        "& p": {
          display: "inline",
          margin: "auto 0px",
        },
        "&:before": {
          content: "'\\2022'",
          fontWeight: "bold",
          display: "inline-block",
          width: "1em",
          fontSize: "2em",
          marginLeft: "-1em",
          color: "#999999",
        },
      },
    },
    title: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontWeight: 600,
    },
    content: {
      marginBottom: theme.spacing(1),
    },
    closeButton: {
      color: "#F54040",
      background: "#F4F4F4",
    },
    centerContent: {
      display: "flex",
      alignItems: "center"
    },
    nameDiv: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px",
      "&.border": {
        borderBottom: "1px dashed #999999"
      }
    },
    esignButton: {
      textTransform: "none",
      width: "150px"
    },
    completed: {
      textTransform: "none",
      width: "150px",
      color: "#028A0F",
      border: "1px solid #3Cb043",
      background: "#3cb04329"
    },
    name: {
      fontWeight: 600
    }
  }

  return (
    <Dialog open={data.show}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      maxWidth={"md"}>
      <DialogTitle>
        <Grid container>
          <Grid item xl={11} lg={11} md={10} sm={11} xs={10} className={classes.title} style={{ textAlign: "center" }}>{localeText?.finalSubmitESignList}</Grid>
          <Grid item xl={1} lg={1} md={2} sm={1} xs={2}>
            <Tooltip title="Close" aria-label="close">
              <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Grid container spacing={3} justifyContent={"center"} alignItems={"center"}>
          {
            data && data.esignData && data.esignData.length > 0 && data.esignData.map((ele, i) => (
              <Grid item>
                <div className={[classes.nameDiv, (ele.guardian && Object.keys(ele.guardian).length > 0) ? "" : "border"].join(" ")}>
                  <div>
                    <Typography align="center" variant="body2">{`${localeText?.finalSubmitNomineeName} ${i + 1}`}</Typography>
                    <Typography align="center" variant="body1" className={classes.name}>{ele.nomineeFirstName}</Typography>
                  </div>
                  {
                    ele.isESignNomineeRequired ?
                      !ele.isESignNomineeDone ?
                        <Button disabled={loading} color="primary" className={classes.esignButton} variant="contained" onClick={() => onEsignClick({ nominee: true, signer: ele.signerType, count: i + 1, user: false })}>
                          {loading ? <CircularProgress size={24} style={{ marginLeft: '-20px', marginRight: '16px', color: '#00000042' }} /> : ""}{localeText?.finalSubmitPending}
                        </Button>
                        :
                        <Button variant="outlined" onClick={() => { }} className={classes.completed}>
                          {localeText?.finalSubmitCompleted}
                        </Button>
                      :
                      <Typography align="center" variant="body1">NA</Typography>
                  }
                </div>
                {
                  (ele.guardian && Object.keys(ele.guardian).length > 0) ?
                    <div className={[classes.nameDiv, "border"].join(" ")} style={{ paddingTop: 0 }}>
                      <div>
                        <Typography align="center" variant="body2">{`${localeText?.finalSubmitGuardianName} ${i + 1}`}</Typography>
                        <Typography align="center" variant="body1" className={classes.name}>{ele.guardian.guardianFirstName}</Typography>
                      </div>
                      {
                        ele.guardian.isESignGuardianRequired ?
                          !ele.guardian.isESignGuardianDone ?
                            <Button disabled={loading} color="primary" variant="contained" className={classes.esignButton} onClick={() => onEsignClick({ guardian: true, signer: ele.guardian.signerType, count: i + 1, user: false })}>
                              {loading ? <CircularProgress size={24} style={{ marginLeft: '-20px', marginRight: '16px', color: '#00000042' }} /> : ""}{localeText?.finalSubmitPending}
                            </Button>
                            :
                            <Button variant="outlined" onClick={() => { }} className={classes.completed}>
                              {localeText?.finalSubmitCompleted}
                            </Button>
                          :
                          <Typography align="center" variant="body1">{localeText?.finalSubmitNA}</Typography>
                      }
                    </div>
                    :
                    <></>
                }
              </Grid>
            ))
          }
          <Grid item className={classes.nameDiv}>
            <Typography variant="body2">{localeText?.finalSubmitClient}</Typography>
            <Typography variant="body1" className={classes.name}>{clientName || "--"}</Typography>
            <Button disabled={data.disableClient || clientLoading} color="primary" className={classes.esignButton} variant="contained" onClick={() => onEsignClick({ signer: "applicantSignature", user: true })}>
              {clientLoading ? <CircularProgress size={24} style={{ marginLeft: '-20px', marginRight: '16px', color: '#00000042' }} /> : ""}{localeText?.finalSubmitPending}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default /* withStyles(styles) */(NomineeEsignDialog)
